"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleSupportMarker = exports.enableSupportMarker = exports.SUPPORT_MARKER_CLASS = void 0;
var SUPPORT_MARKER_CLASS = 'show-support-marker';
exports.SUPPORT_MARKER_CLASS = SUPPORT_MARKER_CLASS;

var toggleSupportMarker = function toggleSupportMarker() {
  if (!document || !document.documentElement) {
    return;
  }

  var htmlClassList = document.documentElement.classList;

  if (htmlClassList.contains(SUPPORT_MARKER_CLASS)) {
    htmlClassList.remove(SUPPORT_MARKER_CLASS);
  } else {
    htmlClassList.add(SUPPORT_MARKER_CLASS);
  }
};

exports.toggleSupportMarker = toggleSupportMarker;

var enableSupportMarker = function enableSupportMarker(enabled) {
  if (!document || !document.documentElement) {
    return;
  }

  var htmlClassList = document.documentElement.classList;

  if (enabled) {
    htmlClassList.add(SUPPORT_MARKER_CLASS);
  } else {
    htmlClassList.remove(SUPPORT_MARKER_CLASS);
  }
};

exports.enableSupportMarker = enableSupportMarker;